export const PLAYER_HEIGHT = 105;
export const MOBILE_PLAYER_HEIGHT = 132;

export const HEADER_HEIGHT = 118;
export const MOBILE_HEADER_HEIGHT = 135;
